export default [
    {
        key: "af",
        text: "Afrikaans"
    },
    {
        key: "am",
        text: "Amharic - አማርኛ"
    },
    {
        key: "an",
        text: "Aragonese"
    },
    {
        key: "ar",
        text: "Arabic - العربية"
    },
    {
        key: "as",
        text: "Assamese - অসমীয়া"
    },
    {
        key: "ast",
        text: "Asturian - asturianu"
    },
    {
        key: "az",
        text: "Azerbaijani - azərbaycan"
    },
    {
        key: "be",
        text: "Belarusian - беларуская"
    },
    {
        key: "bg",
        text: "Bulgarian - български"
    },
    {
        key: "bn",
        text: "Bangla - বাংলা"
    },
    {
        key: "br",
        text: "Breton - brezhoneg"
    },
    {
        key: "bs",
        text: "Bosnian - bosanski"
    },
    {
        key: "ca",
        text: "Catalan - català"
    },
    {
        key: "ceb",
        text: "Cebuano"
    },
    {
        key: "chr",
        text: "Cherokee - ᏣᎳᎩ"
    },
    {
        key: "ckb",
        text: "Central Kurdish - کوردیی ناوەندی"
    },
    {
        key: "co",
        text: "Corsican"
    },
    {
        key: "cs",
        text: "Czech - Čeština"
    },
    {
        key: "cy",
        text: "Welsh - Cymraeg"
    },
    {
        key: "da",
        text: "Danish - Dansk"
    },
    {
        key: "de",
        text: "German - Deutsch"
    },
    {
        key: "de-AT",
        text: "German (Austria) - Deutsch (Österreich)"
    },
    {
        key: "de-CH",
        text: "German (Switzerland) - Deutsch (Schweiz)"
    },
    {
        key: "de-DE",
        text: "German (Germany) - Deutsch (Deutschland)"
    },
    {
        key: "de-LI",
        text: "German (Liechtenstein) - Deutsch (Liechtenstein)"
    },
    {
        key: "el",
        text: "Greek - Ελληνικά"
    },
    {
        key: "en",
        text: "English"
    },
    {
        key: "en-AU",
        text: "English (Australia)"
    },
    {
        key: "en-CA",
        text: "English (Canada)"
    },
    {
        key: "en-GB",
        text: "English (United Kingdom)"
    },
    {
        key: "en-IN",
        text: "English (India)"
    },
    {
        key: "en-NZ",
        text: "English (New Zealand)"
    },
    {
        key: "en-US",
        text: "English (United States)"
    },
    {
        key: "en-ZA",
        text: "English (South Africa)"
    },
    {
        key: "eo",
        text: "Esperanto - esperanto"
    },
    {
        key: "es",
        text: "Spanish - Español"
    },
    {
        key: "es-419",
        text: "Spanish (Latin America) - Español (Latinoamérica)"
    },
    {
        key: "es-AR",
        text: "Spanish (Argentina) - Español (Argentina)"
    },
    {
        key: "es-CL",
        text: "Spanish (Chile) - Español (Chile)"
    },
    {
        key: "es-CO",
        text: "Spanish (Colombia) - Español (Colombia)"
    },
    {
        key: "es-CR",
        text: "Spanish (Costa Rica) - Español (Costa Rica)"
    },
    {
        key: "es-ES",
        text: "Spanish (Spain) - Español (España)"
    },
    {
        key: "es-HN",
        text: "Spanish (Honduras) - Español (Honduras)"
    },
    {
        key: "es-MX",
        text: "Spanish (Mexico) - Español (México)"
    },
    {
        key: "es-PE",
        text: "Spanish (Peru) - Español (Perú)"
    },
    {
        key: "es-US",
        text: "Spanish (United States) - Español (Estados Unidos)"
    },
    {
        key: "es-UY",
        text: "Spanish (Uruguay) - Español (Uruguay)"
    },
    {
        key: "es-VE",
        text: "Spanish (Venezuela) - Español (Venezuela)"
    },
    {
        key: "et",
        text: "Estonian - eesti"
    },
    {
        key: "eu",
        text: "Basque - euskara"
    },
    {
        key: "fa",
        text: "Persian - فارسی"
    },
    {
        key: "fi",
        text: "Finnish - Suomi"
    },
    {
        key: "fil",
        text: "Filipino"
    },
    {
        key: "fo",
        text: "Faroese - føroyskt"
    },
    {
        key: "fr",
        text: "French - Français"
    },
    {
        key: "fr-CA",
        text: "French (Canada) - Français (Canada)"
    },
    {
        key: "fr-CH",
        text: "French (Switzerland) - Français (Suisse)"
    },
    {
        key: "fr-FR",
        text: "French (France) - Français (France)"
    },
    {
        key: "fy",
        text: "Western Frisian - Frysk"
    },
    {
        key: "ga",
        text: "Irish - Gaeilge"
    },
    {
        key: "gd",
        text: "Scottish Gaelic - Gàidhlig"
    },
    {
        key: "gl",
        text: "Galician - galego"
    },
    {
        key: "gn",
        text: "Guarani"
    },
    {
        key: "gu",
        text: "Gujarati - ગુજરાતી"
    },
    {
        key: "ha",
        text: "Hausa"
    },
    {
        key: "haw",
        text: "Hawaiian - ʻŌlelo Hawaiʻi"
    },
    {
        key: "hi",
        text: "Hindi - हिन्दी"
    },
    {
        key: "hmn",
        text: "Hmong"
    },
    {
        key: "hr",
        text: "Croatian - Hrvatski"
    },
    {
        key: "ht",
        text: "Haitian Creole - Créole haïtien"
    },
    {
        key: "hu",
        text: "Hungarian - magyar"
    },
    {
        key: "hy",
        text: "Armenian - հայերեն"
    },
    {
        key: "ia",
        text: "Interlingua - interlingua"
    },
    {
        key: "id",
        text: "Indonesian - Indonesia"
    },
    {
        key: "ig",
        text: "Igbo"
    },
    {
        key: "is",
        text: "Icelandic - íslenska"
    },
    {
        key: "it",
        text: "Italian - Italiano"
    },
    {
        key: "it-CH",
        text: "Italian (Switzerland) - Italiano (Svizzera)"
    },
    {
        key: "it-IT",
        text: "Italian (Italy) - Italiano (Italia)"
    },
    {
        key: "iw",
        text: "Hebrew - עברית"
    },
    {
        key: "ja",
        text: "Japanese - 日本語"
    },
    {
        key: "jv",
        text: "Javanese - Jawa"
    },
    {
        key: "ka",
        text: "Georgian - ქართული"
    },
    {
        key: "kk",
        text: "Kazakh - қазақ тілі"
    },
    {
        key: "km",
        text: "Khmer - ខ្មែរ"
    },
    {
        key: "kn",
        text: "Kannada - ಕನ್ನಡ"
    },
    {
        key: "ko",
        text: "Korean - 한국어"
    },
    {
        key: "kok",
        text: "Konkani - कोंकणी"
    },
    {
        key: "ku",
        text: "Kurdish - kurdî"
    },
    {
        key: "ky",
        text: "Kyrgyz - кыргызча"
    },
    {
        key: "la",
        text: "Latin"
    },
    {
        key: "lb",
        text: "Luxembourgish - Lëtzebuergesch"
    },
    {
        key: "ln",
        text: "Lingala - lingála"
    },
    {
        key: "lo",
        text: "Lao - ລາວ"
    },
    {
        key: "lt",
        text: "Lithuanian - lietuvių"
    },
    {
        key: "lv",
        text: "Latvian - latviešu"
    },
    {
        key: "mg",
        text: "Malagasy"
    },
    {
        key: "mi",
        text: "Māori"
    },
    {
        key: "mk",
        text: "Macedonian - македонски"
    },
    {
        key: "ml",
        text: "Malayalam - മലയാളം"
    },
    {
        key: "mn",
        text: "Mongolian - монгол"
    },
    {
        key: "mr",
        text: "Marathi - मराठी"
    },
    {
        key: "ms",
        text: "Malay - Melayu"
    },
    {
        key: "mt",
        text: "Maltese - Malti"
    },
    {
        key: "my",
        text: "Burmese - မြန်မာ"
    },
    {
        key: "ne",
        text: "Nepali - नेपाली"
    },
    {
        key: "nl",
        text: "Dutch - Nederlands"
    },
    {
        key: "nn",
        text: "Norwegian Nynorsk - norsk nynorsk"
    },
    {
        key: "no",
        text: "Norwegian - norsk"
    },
    {
        key: "ny",
        text: "Nyanja"
    },
    {
        key: "oc",
        text: "Occitan"
    },
    {
        key: "om",
        text: "Oromo - Oromoo"
    },
    {
        key: "or",
        text: "Odia - ଓଡ଼ିଆ"
    },
    {
        key: "pa",
        text: "Punjabi - ਪੰਜਾਬੀ"
    },
    {
        key: "pl",
        text: "Polish - polski"
    },
    {
        key: "ps",
        text: "Pashto - پښتو"
    },
    {
        key: "pt",
        text: "Portuguese - Português"
    },
    {
        key: "pt-BR",
        text: "Portuguese (Brazil) - Português (Brasil)"
    },
    {
        key: "pt-PT",
        text: "Portuguese (Portugal) - Português (Portugal)"
    },
    {
        key: "qu",
        text: "Quechua - Runasimi"
    },
    {
        key: "rm",
        text: "Romansh - rumantsch"
    },
    {
        key: "ro",
        text: "Romanian - română"
    },
    {
        key: "ru",
        text: "Russian - Русский"
    },
    {
        key: "rw",
        text: "Kinyarwanda"
    },
    {
        key: "sd",
        text: "Sindhi - سنڌي"
    },
    {
        key: "si",
        text: "Sinhala - සිංහල"
    },
    {
        key: "sk",
        text: "Slovak - Slovenčina"
    },
    {
        key: "sl",
        text: "Slovenian - slovenščina"
    },
    {
        key: "sm",
        text: "Samoan"
    },
    {
        key: "sn",
        text: "Shona - chiShona"
    },
    {
        key: "so",
        text: "Somali - Soomaali"
    },
    {
        key: "sq",
        text: "Albanian - shqip"
    },
    {
        key: "sr",
        text: "Serbian - српски"
    },
    {
        key: "st",
        text: "Southern Sotho"
    },
    {
        key: "su",
        text: "Sundanese - Basa Sunda"
    },
    {
        key: "sv",
        text: "Swedish - Svenska"
    },
    {
        key: "sw",
        text: "Swahili - Kiswahili"
    },
    {
        key: "ta",
        text: "Tamil - தமிழ்"
    },
    {
        key: "te",
        text: "Telugu - తెలుగు"
    },
    {
        key: "tg",
        text: "Tajik - тоҷикӣ"
    },
    {
        key: "th",
        text: "Thai - ไทย"
    },
    {
        key: "ti",
        text: "Tigrinya - ትግርኛ"
    },
    {
        key: "tk",
        text: "Turkmen - türkmen dili"
    },
    {
        key: "tn",
        text: "Tswana"
    },
    {
        key: "to",
        text: "Tongan - lea fakatonga"
    },
    {
        key: "tr",
        text: "Turkish - Türkçe"
    },
    {
        key: "tt",
        text: "Tatar - татар"
    },
    {
        key: "ug",
        text: "Uyghur - ئۇيغۇرچە"
    },
    {
        key: "uk",
        text: "Ukrainian - Українська"
    },
    {
        key: "ur",
        text: "Urdu - اردو"
    },
    {
        key: "uz",
        text: "Uzbek - o‘zbek"
    },
    {
        key: "vi",
        text: "Viettextse - Tiếng Việt"
    },
    {
        key: "wa",
        text: "Walloon"
    },
    {
        key: "wo",
        text: "Wolof"
    },
    {
        key: "xh",
        text: "Xhosa - IsiXhosa"
    },
    {
        key: "yi",
        text: "Yiddish - ייִדיש"
    },
    {
        key: "yo",
        text: "Yoruba - Èdè Yorùbá"
    },
    {
        key: "zh",
        text: "Chinese - 中文"
    },
    {
        key: "zh-CN",
        text: "Chinese (Simplified) - 简体中文"
    },
    {
        key: "zh-HK",
        text: "Chinese (Hong Kong) - 中文（香港）"
    },
    {
        key: "zh-TW",
        text: "Chinese (Traditional) - 繁體中文"
    },
    {
        key: "zu",
        text: "Zulu - isiZulu"
    }
];
